/**
* Carousel Footer selector
*
* This function create an selector
*
*/

export const results = (state) => state.carouselFooterReducer;
export const resultsItems = (state) => state.carouselFooterReducer.data.data;
